/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export { PlaygroundReactRenderer as EditorRenderer } from '@flowgram.ai/core';
